import { useNavigate, useSearchParams } from 'react-router-dom';
import clsx from 'clsx';
import { useRegistration } from 'lib/context/RegistrationContext/RegistrationContext';
import styles from './Stepper.module.scss';

export default function StepperBars() {
  const { stepNumber, steps } = useRegistration();

  function generateStepperBars() {
    return Object.entries(steps).map(([key, value], idx) => {
      const hasVisited = stepNumber >= idx + 1;
      return (
        <StepperBar
          label={value.shortDesc}
          key={key}
          path={key}
          visited={hasVisited}
        />
      );
    });
  }

  return <div className={styles.stepperBars}>{generateStepperBars()}</div>;
}

export function StepperBar({
  label,
  path,
  visited,
}: Readonly<{
  label: string;
  path: string;
  visited: boolean;
}>) {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const searchParamsString = Array.from(searchParams.entries())
    .map(([key, value]) => `${key}=${value}`)
    .join('&');
  let registrationPath = `/app/registration`;
  if (path !== 'basic-info') {
    registrationPath += `/${path}`;
  }
  if (searchParams.size) {
    registrationPath += `?${searchParamsString}`;
  }

  const visitedBar = clsx(
    styles.stepperBarContainer,
    visited && styles.visited
  );

  const handleStepClick = (): void => {
    if (visited) {
      navigate(registrationPath);
    }
  };

  return (
    <button type="button" onClick={handleStepClick} className={visitedBar}>
      <span className={styles.stepperBar} />
      <span className={styles.barLabel}>{label}</span>
    </button>
  );
}
